<ng-container *ngIf="appointmentServices$ | async as data">
  <div class="service-item w-full flex" *ngFor="let service of data; first as isFirst; last as isLast" [ngClass]="{'!mb-0': isLast}">
    <div class="w-full">

      <div class="flex">

        <div class="flex-col">
          <div class="service-item__name text-[20px] font-medium mb-[8px]"
               data-test-id="appointment-service-name">{{service.serviceName}}</div>
          <pub-service-duration-and-price
            class="mb-[8px]"
            [hideClock]="true"
            [duration]="service.totalDuration"
            [price]="service.price">
          </pub-service-duration-and-price>
        </div>

        <ng-container *ngIf="startDate$ | async as startDate">
          <pub-appointment-date-widget
            *ngIf="isFirst"
            [date]="startDate"
            class="ml-[10px]">
          </pub-appointment-date-widget>
        </ng-container>

      </div>

      <div class="service-item__name text-[17px] font-medium line-clamp-1 break-words" data-test-id="appointment-employee-name">
        <ng-container *ngIf="service.employee; else noEmployeeSelection">
          {{ service.employee.firstName }} {{ service.employee.lastName}}
        </ng-container>
        <ng-template #noEmployeeSelection>
          <pub-no-employee-selection></pub-no-employee-selection>
        </ng-template>
      </div>

    </div>

  </div>
</ng-container>

<ng-container *ngIf="appointmentServicesSum$ | async as sum">
  <div
    class="appointment-table__total-price text-[14px] font-bold leading-[24px] pt-[14px] pb-[14px]"
    [translate]="'bookingPage.confirmAppointmentPage.totalAmount'"
    [translateParams]="{ amount: sum | formatMoney }"
    data-test-id="appointment-total-price"></div>
</ng-container>

<pub-appointment-external-note class="mt-[25px] empty:hidden"></pub-appointment-external-note>
